(function () {
  var data = window.FTL_HELP_CENTER_SEARCH_DATA || [];
  var forms = document.querySelectorAll('[data-help-center-search]');
  var maxResults = 8;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function scoreItem(item, query) {
    var title = normalize(item.title);
    var category = normalize(item.categoryTitle + ' ' + item.categorySlug);
    var keywords = normalize(item.keywords);
    var description = normalize(item.description);
    var slug = normalize(item.slug);
    var haystack = [title, category, keywords, description, slug].join(' ');
    var score = 0;

    if (!query || haystack.indexOf(query) === -1) {
      return 0;
    }

    if (title === query) score += 120;
    if (title.indexOf(query) === 0) score += 80;
    if (title.indexOf(query) > -1) score += 60;
    if (slug.indexOf(query) > -1) score += 35;
    if (category.indexOf(query) > -1) score += 24;
    if (keywords.indexOf(query) > -1) score += 18;
    if (description.indexOf(query) > -1) score += 8;

    return score;
  }

  function search(query) {
    var normalizedQuery = normalize(query);

    if (!normalizedQuery) {
      return [];
    }

    return data
      .map(function (item) {
        return {
          item: item,
          score: scoreItem(item, normalizedQuery)
        };
      })
      .filter(function (entry) {
        return entry.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.item.title.localeCompare(b.item.title);
      })
      .slice(0, maxResults)
      .map(function (entry) {
        return entry.item;
      });
  }

  function createPanel(form) {
    var panel = document.createElement('div');
    panel.className = 'ftl-help-search-panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);
    return panel;
  }

  function render(panel, results, hasQuery) {
    if (!hasQuery) {
      panel.hidden = true;
      panel.innerHTML = '';
      return;
    }

    panel.hidden = false;

    if (!results.length) {
      panel.innerHTML = '<div class="ftl-help-search-panel__empty">No results found. Try another keyword or contact support.</div>';
      return;
    }

    panel.innerHTML = results.map(function (item) {
      var description = item.description
        ? '<p>' + escapeHtml(item.description) + '</p>'
        : '';

      return [
        '<a class="ftl-help-search-panel__result" href="', escapeAttribute(item.url), '" role="option">',
          '<span class="ftl-help-search-panel__category">', escapeHtml(item.categoryTitle), '</span>',
          '<strong>', escapeHtml(item.title), '</strong>',
          description,
        '</a>'
      ].join('');
    }).join('');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  forms.forEach(function (form) {
    var input = form.querySelector('input[name="s"]');
    var panel = createPanel(form);
    var currentResults = [];

    if (!input) {
      return;
    }

    input.setAttribute('autocomplete', 'off');

    input.addEventListener('input', function () {
      currentResults = search(input.value);
      render(panel, currentResults, Boolean(normalize(input.value)));
    });

    input.addEventListener('focus', function () {
      if (normalize(input.value)) {
        currentResults = search(input.value);
        render(panel, currentResults, true);
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      currentResults = search(input.value);
      render(panel, currentResults, Boolean(normalize(input.value)));

      if (currentResults.length) {
        window.location.href = currentResults[0].url;
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) {
        panel.hidden = true;
      }
    });
  });
})();
